import { APLICACAO_ROTAS_PARCERIAS } from "src/app/abertura-conta/config/constants/aplicacao-rotas-parcerias.const";

export const FLUXO_PARCERIAS: Array<string> = [
    APLICACAO_ROTAS_PARCERIAS.dadosPessoais.rota,
    APLICACAO_ROTAS_PARCERIAS.dadosComplementares.rota,
    APLICACAO_ROTAS_PARCERIAS.documentosProponentesUpload.rota,
    APLICACAO_ROTAS_PARCERIAS.assinaturaDigitalParcerias.rota,
    APLICACAO_ROTAS_PARCERIAS.statusAnalise.rota,
]

